import Offcanvas from "react-bootstrap/Offcanvas";

function ReactCanvasModal({ show, setShow, title, htmlBody, ...props }) {
  const handleClose = () => setShow(false);

  return (
    <>
      <Offcanvas show={show} onHide={handleClose} {...props}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>{htmlBody}</Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default ReactCanvasModal;
